import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosPersonalizados = ({ paginapersonalizada, ruta }) => {
    const { t } = useTranslation();
    return (
        <PaginaTexto
            titulo={paginapersonalizada.eltitulo}
            eyebrow={t("Empresa")}
            imagen={paginapersonalizada.logo_pagina ? ruta + "/paginapersonalizada/" + paginapersonalizada.id + "/" + paginapersonalizada.logo_pagina : null}
            html={paginapersonalizada.eltexto}
        />
    );
}

export default TextosPersonalizados;
